import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Download: FC<ISvG> = ({ fill = "#959697" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
    >
      <g>
        <g>
          <path
            fill={fill}
            d="M10.672 3.853L6.61 8.238l-4.072-4.39-1.076.997L5.575 9.28a1.402 1.402 0 0 0 2.075-.005l4.099-4.425z"
          />
        </g>
        <g>
          <path fill={fill} d="M5.87 8.992v-9h1.468v9z" />
        </g>
        <g>
          <path fill={fill} d="M0 12.668V11.2h13.208v1.468z" />
        </g>
      </g>
    </svg>
  );
};

export default memo(Download);
